// 1. Personal Pronouns / Subject Pronouns
// 2. Object Pronouns
// 3. Possessive Pronouns
// 4. Reflexive Pronouns

export const pronouns = [
  'i',
  'we',
  'you',
  'he',
  'she',
  'it',
  'they',
  'me',
  'us',
  'her',
  'him',
  'them',
  'mine',
  'ours',
  'yours',
  'hers',
  'his',
  'theirs',
  'myself',
  'yourself',
  'herself',
  'himself',
  'itself',
  'ourselves',
  'yourselves',
  'themselves',
]
